import type { JSX, ReactNode } from 'react';

import Box from '@mui/material/Box';
import styled from 'styled-components';

interface TooltipImageProps {
  src?: string;
}

const TooltipImage = styled.img<TooltipImageProps>`
  width: 100%;
  max-width: 120px;
  height: auto;
  display: block;
  src: ${({ src }) => (src ? `url(${src})` : 'none')};
`;

const TooltipStack = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin: 0;
  padding: 0;
  width: 100%;
  box-sizing: border-box;
`;

const TooltipBox = styled(Box)`
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding: 4px 8px;
  margin: 0;
  border-radius: 8px;
  background: var(--neutral-700);
  color: #fff;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;

  @media only screen and (max-width: 700px) {
    width: 100%;
    max-width: 100%;
  }
`;

const TooltipRoot = styled.div`
  width: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
`;


interface TooltipComponentProps {
  title?: ReactNode;
  image?: string;
  isOpen: boolean;
}

function TooltipComponent({
  title,
  image,
  isOpen
}: TooltipComponentProps): JSX.Element {
  return (
    <TooltipRoot>
      {title !== undefined && isOpen && (
        <TooltipStack>
          <TooltipBox data-testid="tooltip-box">
            {title}
          </TooltipBox>

          {image && (
            <TooltipImage
              src={image}
              role="img"
              aria-label="tooltip-img"
            />
          )}
        </TooltipStack>
      )}
    </TooltipRoot>
  );
}

export default TooltipComponent;